import React, { useState } from 'react';

import MainHeader from '../../ui-components/MainHeader';
import TopHeaderUi from '../../ui-components/TopHeaderUi';

import TaskTable from './TaskTable';
import TaskConfigurationModal from './TaskConfigurationModal';
import SendToPdModal from './SendToPdModal';
import UpdateTaskModal from './UpdateTaskModal';
import CreateIssueSidebar from './CreateIssueSidebar';
import Send3dModal from './Send3dModal';
import CostingTable from './CostingTable';
import JourneyTable from './JourneyTable';
import UpdateSampleDetailModal from './UpdateSampleDetailModal';

const ComponentWrapper = () => {
	const [activeTab, setActiveTab] = useState('Task Configuration');
	const uiTabs = [
		'Task Configuration',
		'Create Task',
		'Send to PD',
		'Update Task',
		'Create Issue',
		'Send 3D',
		'Costing Table',
		'Journey Configuration',
		'Update Sample Detail'
	];

	const renderComponents = () => {
		switch (activeTab) {
			case 'Task Configuration':
				return <TaskTable />;
			case 'Journey Configuration':
				return <JourneyTable />;
			case 'Create Task':
				return <TaskConfigurationModal />;
			case 'Send to PD':
				return <SendToPdModal />;
			case 'Update Task':
				return <UpdateTaskModal />;
			case 'Create Issue':
				return <CreateIssueSidebar />;
			case 'Send 3D':
				return <Send3dModal />;
			case 'Costing Table':
				return <CostingTable />;
			case 'Update Sample Detail':
				return <UpdateSampleDetailModal />;
			default:
				return null;
		}
	};

	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default ComponentWrapper;
